"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadMarkets = void 0;
const serum_1 = require("@project-serum/serum");
const web3_js_1 = require("@solana/web3.js");
async function loadMarkets(accounts, options, parsedMarkets, serumMarketId = new web3_js_1.PublicKey("CxEUdaCt9TViHQPVAxEZS4E7qhwVqgx7rVQUHd26SuT4")) {
    const serumMarket = new web3_js_1.PublicKey(serumMarketId);
    const allMarkets = accounts.result?.value.map((item, i) => {
        const { data } = item;
        const myBuffer = Buffer.from(data[0], data[1]);
        const decoded = serum_1.Market.getLayout(new web3_js_1.PublicKey(parsedMarkets[i])).decode(myBuffer);
        const baseMintDecimals = 6;
        const quoteMintDecimals = 6;
        return new serum_1.Market(decoded, baseMintDecimals, quoteMintDecimals, options, serumMarket);
    });
    return allMarkets;
}
exports.loadMarkets = loadMarkets;
//# sourceMappingURL=loadMarkets.js.map